module.exports = __webpack_public_path__ + "static/media/social-wordpress.400be8ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/auth/social-wordpress.svg
// module id = 167
// module chunks = 0